// Contentful
import resolveResponse from 'contentful-resolve-response';
import safeJsonStringify from 'safe-json-stringify';
import contentfulClient from '../../../client/contentful';

// Components
import OgImage from '../../../components/OgImage/OgImage';

// Data Utils
import getPlaybookHeaderData from '../../../utils/data/getPlaybookHeaderData';

const Playbook = (props) => {
  const data = resolveResponse(props.playbook)[0];

  const playbookHeaderData = getPlaybookHeaderData(data);

  return <>{playbookHeaderData && <OgImage {...playbookHeaderData} />}</>;
};

export async function getStaticPaths() {
  const client = contentfulClient;
  let entries = [];
  await client
    .getEntries({
      content_type: 'playbook',
    })
    .then((data) => {
      entries = data.items;
    });
  // .catch(console.error);

  // Map the slug for the playubook entries
  const paths = entries.map((item) => ({ params: { slug: item.fields.slug } }));

  return {
    paths,
    fallback: false,
  };
}

export async function getStaticProps({ params }) {
  const client = contentfulClient;
  let entryTemp = {};

  // Fetch data from contentful using created fields
  await client
    .getEntries(
      {
        content_type: 'playbook',
        'fields.slug': params.slug,
        include: 4,
      },
      {
        content_type: 'playbook',
        'fields.slug': params.slug,
        include: 1,
      },
    )
    .then((entry) => {
      entryTemp = entry;
    });

  // .catch(console.error) TODO: bugsnag;

  return {
    props: {
      playbook: JSON.parse(safeJsonStringify(entryTemp)),
    },
  };
}

export default Playbook;
